const DEFAULT_API_BASE_URL = 'https://supernovalab.ai/api';

const trimTrailingSlashes = (value) => value.replace(/\/+$/, '');

/**
 * Use the configured API host exactly as supplied. Supernova's frontend must
 * send every API request to the canonical non-www production API, including
 * when the frontend itself is running on localhost or the www hostname.
 */
export const resolveApiBaseUrl = (
  configuredApiUrl = process.env.REACT_APP_API_URL
) => {
  const candidate = trimTrailingSlashes(
    (configuredApiUrl || DEFAULT_API_BASE_URL).trim()
  );

  if (!candidate) return DEFAULT_API_BASE_URL;
  return candidate;
};

export const API_BASE_URL = resolveApiBaseUrl();

export const MEDIA_BASE_URL = (() => {
  if (API_BASE_URL.startsWith('/')) return '';

  try {
    return new URL(API_BASE_URL).origin;
  } catch (error) {
    return API_BASE_URL.replace(/\/api\/?$/, '');
  }
})();
